import Lottie from 'lottie-react';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import starAnimated from '../../../assets/lottie/star.json';

export const StarRating = ({onChangeRating}) => {
  const [rating, setRating] = useState(0)

  const lottieRefs1 = useRef()
  const lottieRefs2 = useRef()
  const lottieRefs3 = useRef()
  const lottieRefs4 = useRef()
  const lottieRefs5 = useRef()

  const ratingRef = useRef(null);

  const handleClick = (index) => {
    setRating(index + 1)
    
  }

  useEffect(() => {

    if (rating === 1) {
      ratingRef.current = 1

      lottieRefs1.current.goToAndPlay(29, true)

      lottieRefs2.current.stop()
      lottieRefs3.current.stop()
      lottieRefs4.current.stop()
      lottieRefs5.current.stop()
    } else if (rating === 2) {
      ratingRef.current = 2

      lottieRefs1.current.goToAndPlay(29, true)
      lottieRefs2.current.goToAndPlay(29, true)

      lottieRefs3.current.stop()
      lottieRefs4.current.stop()
      lottieRefs5.current.stop()
    } else if (rating === 3) {
      ratingRef.current = 3

      lottieRefs1.current.goToAndPlay(29, true)
      lottieRefs2.current.goToAndPlay(29, true)
      lottieRefs3.current.goToAndPlay(29, true)

      lottieRefs4.current.stop()
      lottieRefs5.current.stop()
    } else if (rating === 4) {
      ratingRef.current = 4

      lottieRefs1.current.goToAndPlay(29, true)
      lottieRefs2.current.goToAndPlay(29, true)
      lottieRefs3.current.goToAndPlay(29, true)
      lottieRefs4.current.goToAndPlay(29, true)

      lottieRefs5.current.stop()
    } else if (rating === 5) {
      ratingRef.current = 5

      lottieRefs1.current.goToAndPlay(29, true)
      lottieRefs2.current.goToAndPlay(29, true)
      lottieRefs3.current.goToAndPlay(29, true)
      lottieRefs4.current.goToAndPlay(29, true)
      lottieRefs5.current.goToAndPlay(29, true)
    }

    onChangeRating(rating)
  }, [rating])

  
  

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        // gap: 8, // Espaçamento entre as estrelas
      }}
    >
      {[0, 1, 2, 3, 4].map((index) => (
        <div
          style={{
            width: 40,
            height: 40,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            position: 'relative',
          }}
          key={index}
          onClick={() => handleClick(index)}
        >
            
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-48%, -46%) scale(1.8)', // Aumenta a animação sem aumentar a área clicável
            }}
          >
            <Lottie
              lottieRef={
                index === 0
                  ? lottieRefs1
                  : index === 1
                    ? lottieRefs2
                    : index === 2
                      ? lottieRefs3
                      : index === 3
                        ? lottieRefs4
                        : lottieRefs5
              }
              animationData={starAnimated}
              style={{ width: 50, height: 50 }}
              loop={false}
              autoplay={false}
            />
          </div>
        </div>
      ))}
    </div>
  )
}

StarRating.propTypes = {
  onChangeRating:PropTypes.func
}